import { render, staticRenderFns } from "./LanguageSection.vue?vue&type=template&id=4454ae2c&scoped=true"
import script from "./LanguageSection.vue?vue&type=script&lang=js"
export * from "./LanguageSection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSection.vue?vue&type=style&index=0&id=4454ae2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454ae2c",
  null
  
)

export default component.exports